exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".flameGraphCanvas{position:absolute;top:0;left:0}.flameGraphCanvasTooltip{padding:5px}.flameGraphCanvasTooltip>.tooltipHeader{display:grid;grid-template-columns:min-content auto;grid-gap:2px 0}.flameGraphCanvasTooltip .tooltipTitle{white-space:nowrap;overflow:visible}", ""]);

// exports
